export default __webpack_public_path__ + "static/media/fad-keyboard.f9f3068b.svg";